import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { CategoryComponent } from './category/category.component';
import { SubcategoryComponent } from './subcategory/subcategory.component';
import { SubsubcategoryComponent } from './subsubcategory/subsubcategory.component';
import { FilterProductComponent } from './filter-product/filter-product.component';
import { FilterNavBarComponent } from './filter-nav-bar/filter-nav-bar.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';

import { NgForm, FormsModule } from '@angular/forms';
import { AuthGuardService } from '../guards/auth-guard.service';
@NgModule({
  declarations: [ProductDetailsComponent, CategoryComponent, SubcategoryComponent, SubsubcategoryComponent, FilterProductComponent, FilterNavBarComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbModule,
    NgxImageZoomModule,
    SlickCarouselModule,
    FormsModule,
    RouterModule.forChild([
      { path: 'product-details/:id' , component: ProductDetailsComponent},
      { path: 'filter/:id' , component: FilterProductComponent,canActivate: [AuthGuardService]},
      { path: 'filternav' , component: FilterNavBarComponent},
      { path: 'product-details/:id' , component: ProductDetailsComponent},
      { path: 'subsub/:id' , component: SubsubcategoryComponent},
      { path: 'category', component: CategoryComponent},
      { path: 'subcategory/:id', component: SubcategoryComponent},
    ])
  ]
})
export class ProductsModule { }
